import { render, staticRenderFns } from "./TweetVariationCard.vue?vue&type=template&id=ccf43688&scoped=true&"
import script from "./TweetVariationCard.vue?vue&type=script&lang=js&"
export * from "./TweetVariationCard.vue?vue&type=script&lang=js&"
import style0 from "./TweetVariationCard.vue?vue&type=style&index=0&id=ccf43688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf43688",
  null
  
)

export default component.exports